import { Box, Typography } from '@mui/material';
import * as React from 'react';

interface CharacterCounterProps {
  currentLength: number;
  maxLength?: number;
}

export const CharacterCounter: React.FC<CharacterCounterProps> = ({
  currentLength,
  maxLength,
}) => {
  const isNearLimit = maxLength && currentLength >= maxLength * 0.9;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        mt: 1,
        px: 1,
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Roboto-Regular !important',
          fontSize: '9pt !important',
          color: '#9ca3af !important',
        }}
      >
        {maxLength ? `Mínimo recomendado: 50 caracteres` : 'Resposta livre'}
      </Typography>
      <Typography
        sx={{
          fontFamily: 'Roboto-Medium !important',
          fontSize: '9pt !important',
          color: isNearLimit ? '#ef4444 !important' : '#667eea !important',
        }}
      >
        {currentLength}
        {maxLength ? ` / ${maxLength}` : ''} caracteres
      </Typography>
    </Box>
  );
};

CharacterCounter.defaultProps = {
  maxLength: undefined,
};
